<!--
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2023-11-17 09:00:49
 * @LastEditTime : 2024-07-05 14:39:13
 * @LastEditors  : yangxr
 * @Description  : 处罚台账
 * @FilePath     : \icps_fb\src\views\platform\ICPS\smart\penaltyLedger.vue
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <el-collapse-transition>
          <div v-show="showCardNav">
            <div class="search">
              <span style="display: inline-block; margin-bottom: 0.625rem">
                <span style="margin-right: 0.75rem">合同签订主体</span>
                <el-input v-model="tableParam.contractSigningSubject" style="width: 200px" clearable placeholder="请输入" />
              </span>
              <span style="margin-left: 0.75rem">
                <span style="margin-right: 0.75rem">协调主体</span>
                <el-input v-model="tableParam.cooperativeUnit" style="width: 200px" clearable placeholder="请输入" />
              </span>
              <span style="margin-left: 0.75rem">
                <span style="margin-right: 0.75rem">站点</span>
                <el-select v-model="tableParam.stationId" placeholder="请选择" style="width: 120px">
                  <el-option v-for="(item, index) in pointIdListArr" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </span>
              <span style="margin-left: 0.75rem">
                <span style="margin-right: 0.75rem">处罚类型</span>
                <el-select v-model="tableParam.fineTypeId" style="width: 10rem" placeholder="请选择">
                  <el-option v-for="item in ledgerList" :key="item.id" :label="item.itemName" :value="item.id"></el-option>
                </el-select>
              </span>
              <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="gettableData()">查 询</el-button>
              <el-button size="medium" class="bottom_all_two" style="margin-left: 0.75rem" @click="init()">重 置</el-button>
            </div>
          </div>
        </el-collapse-transition>
        <div class="hr"></div>
        <div class="card">
          <div class="card_nav" style="height: 45px">
            <div>
              <el-button size="small" class="bottom_all" style="margin-left: 0" @click="addFromDate('添加处罚')"> 添加处罚</el-button>
              <el-button v-if="ButtonList.findIndex(res => res.buttonValue == 'TIJIAOSHENHE') !== -1" size="small" class="bottom_all" style="margin-left: 10px" @click="selectFromDate()"> 审 核 </el-button>
            </div>
            <div>
              <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 1.25rem">
                <el-link :underline="false">
                  <span class="el-icon--left"> <i class="iconfont iconicon_button_filtrate"></i> </span>筛选
                </el-link>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in table" :key="index">
                    <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <!-- <el-link :underline="false" @click="load()">
                <span class="el-icon--left">
                  <i class="iconfont iconicon_button_export1"></i>
                </span>导出
              </el-link> -->
            </div>
          </div>
          <div v-loading="tableLoading" class="card_info">
            <el-table
              :header-cell-style="{ background: '#f3f6f9' }"
              :height="screenHeight - 450"
              :cell-style="{ borderRight: 'none' }"
              border
              style="width: 100%"
              :data="tableData"
              tooltip-effect="dark"
              @selection-change="handleSelectionChange2"
            >
              <el-table-column align="center" type="selection" width="50" :selectable="checkSelect"></el-table-column>
              <template v-for="(item, index2) in table">
                <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :width="item.width">
                  <template slot-scope="scope">
                    <span v-if="item.label == '状态'">
                      <span v-if="scope.row.checkStatus == 0">未审核</span>
                      <span v-if="scope.row.checkStatus == 1">已提交审核</span>
                      <span v-if="scope.row.checkStatus == 2">未通过</span>
                      <span v-if="scope.row.checkStatus == 3">已通过</span>
                      <span v-if="scope.row.checkStatus == 4">已结算</span>
                    </span>
                    <span v-else-if="item.label == '处罚单'">
                      <span></span>
                      <span class="loadItem" @click="(lookFileConfig.filePaths = JSON.stringify(scope.row.fineFile)), (lookFileVisible = true)">{{ scope.row.fineFile.length > 0 ? scope.row.fineFile[0].name : "" }}</span>
                    </span>
                    <span v-else-if="item.label == '操作'">
                      <el-button
                        v-if="scope.row.checkStatus == 0 || scope.row.checkStatus == 2 || scope.row.checkStatus == 1"
                        size="mini"
                        style="margin: 0.3125rem 0"
                        class="bottom_one"
                        @click="updateFromDate(scope.row, '修改'), getUint(scope.row), (lookStatus = false)"
                        >修改</el-button
                      >
                      <el-button
                        v-if="scope.row.checkStatus == 3 || scope.row.checkStatus == 4"
                        size="mini"
                        style="margin: 0.3125rem 0"
                        class="bottom_one"
                        @click="updateFromDate(scope.row, '查看'), getUint(scope.row), (lookStatus = true)"
                        >查看</el-button
                      >
                      <el-button v-if="scope.row.checkStatus == 0 || scope.row.checkStatus == 2 || scope.row.checkStatus == 1" size="mini" style="margin: 0.3125rem 0.2rem" class="bottom_one" @click="DelItem(scope.row)"
                        >删除</el-button
                      >
                    </span>
                    <span v-else>{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination
            :current-page.sync="tableParam.page"
            :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="total"
            @size-change="sizeChange"
            @current-change="gettableData()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 添加发票 -->
    <el-dialog v-dialogDrag :visible.sync="addDialog" width="860px" :close-on-click-modal="false" :before-close="resetFromDate">
      <span slot="title" class="dialog-title">{{ addDialogTitle }}</span>
      <div class="dialoginfo">
        <el-form ref="reffromDate" :rules="rules" :inline="true" :model="fromDate" label-width="135px">
          <el-form-item prop="fineTypeId">
            <span slot="label">处罚类型:</span>
            <el-select v-model="fromDate.fineTypeId" :disabled="lookStatus" style="width: 230px" placeholder="请选择">
              <el-option v-for="item in ledgerList" :key="item.id" :label="item.itemName" :value="item.id" @click.native="fromDate.fineTypeName = item.itemName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="contractSigningSubjectId">
            <span slot="label">合同签订主体</span>
            <span v-if="!fromDate.contractSigningSubjectId" style="color: #1cc073" @click="getSupplyInfo()">请选择</span>
            <span v-else style="color: #1cc073" @click="getSupplyInfo()">{{ fromDate.contractSigningSubject }}</span>
          </el-form-item>
          <el-form-item prop="supplierName">
            <span slot="label">合同单位</span>
            <el-input v-model="fromDate.supplierName" disabled style="width: 230px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item prop="projectId">
            <span slot="label">项目</span>
            <el-select v-model="fromDate.projectId" :disabled="lookStatus" placeholder="请选择" style="width: 230px">
              <el-option v-for="(item, index) in projectList" :key="index" :label="item.itemName" :value="item.id" @click.native="fromDate.projectName = item.itemName"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="cooperativeUnitId">
            <span slot="label">协作单位</span>
            <el-select v-model="fromDate.cooperativeUnitId" :disabled="lookStatus" placeholder="请选择" style="width: 230px">
              <el-option
                v-for="(item, index) in cooperativeUnitList"
                :key="index"
                :label="item.collaborativeUnit"
                :value="item.collaborativeUnitId"
                @click.native="(fromDate.taxRate = item.collaborativeUnitTaxRate), (fromDate.contractCode = item.collaborativeContractNumber), (fromDate.cooperativeUnit = item.collaborativeUnit)"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="contractCode">
            <span slot="label">协作合同编码</span>
            <el-input v-model="fromDate.contractCode" disabled style="width: 230px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item prop="stationId">
            <span slot="label">站点</span>
            <el-select
              ref="selection2"
              v-model="fromDate.stationId"
              :disabled="lookStatus"
              style="width: 230px"
              @change="
                $nextTick(() => {
                  fromDate.stationName = $refs.selection2.selectedLabel;
                })
              "
            >
              <el-option v-for="(item, index) in siteIdList" :key="index" :label="item.stationName" :value="item.stationId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="fineNumber">
            <span slot="label">处罚单编号</span>
            <el-input v-model="fromDate.fineNumber" :disabled="lookStatus" style="width: 230px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item prop="fineTime">
            <span slot="label">处罚时间</span>
            <el-date-picker v-model="fromDate.fineTime" :disabled="lookStatus" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width: 230px"></el-date-picker>
          </el-form-item>
          <el-form-item prop="fineReason">
            <span slot="label">处罚依据</span>
            <el-input v-model="fromDate.fineReason" :disabled="lookStatus" style="width: 230px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item prop="fineMoney">
            <span slot="label">处罚金额</span>
            <el-input v-model="fromDate.fineMoney" :disabled="lookStatus" style="width: 230px" clearable placeholder="请输入" />
          </el-form-item>
          <el-form-item>
            <span slot="label">处罚单上传</span>
            <FileComponent fileCode="contractFile" :files="files" @deleteFile="deleteFile" @uplodeSuccess="uplodeSuccess" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetFromDate">取 消</el-button>
        <el-button v-if="!lookStatus" class="bottom_all" style="margin-left: 24px" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 选择供应商 -->
    <el-dialog v-dialogDrag :visible.sync="supplierDialog" title="选择供应商" width="860px" :close-on-click-modal="false" :before-close="resetSupplyFrom">
      <div>
        <div style="padding-bottom: 20px">
          <span style="display: inline-block; margin-bottom: 0.625rem">
            <span style="margin-right: 0.75rem">合同签订主体</span>
            <el-input v-model="tableParamSupply.contractSigningSubject" style="width: 100px" clearable placeholder="请输入" />
          </span>
          <!-- <span >
              <span style="margin-left: 0.75rem;margin-right;: 0.75rem">合同编码</span>
              <el-input v-model="tableParamSupply.contractNumber" style="width: 100px" clearable placeholder="请输入" />
          </span> -->
          <span>
            <span style="margin-left: 0.75rem;margin-right;: 0.75rem">供应商名称</span>
            <el-input v-model="tableParamSupply.supplierName" style="width: 100px" clearable placeholder="请输入" />
          </span>
          <el-button icon="el-icon-search" size="mini" class="bottom_all" @click="getSupplyInfo()">查 询</el-button>
        </div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe style="width: 100%" :data="contractData" tooltip-effect="dark" @selection-change="handleSelectionChange">
          <el-table-column align="center" type="selection" width="50"></el-table-column>
          <el-table-column label="合同签订主体" align="center" prop="contractSigningSubject"></el-table-column>
          <el-table-column label="供应商名称" align="center" prop="supplierName"></el-table-column>
          <el-table-column label="项目" align="center" prop="rawType"></el-table-column>
          <el-table-column label="合同" align="center" prop="contractNumber"></el-table-column>
        </el-table>
      </div>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ totalSupply }}条</div>
          <el-pagination
            :current-page.sync="tableParamSupply.page"
            :page-size="tableParamSupply.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]"
            layout="prev,pager,sizes,next,jumper"
            :total="totalSupply"
            @size-change="sizeChangeSupply"
            @current-change="getSupplyInfo()"
          ></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="getSupplyInfo">刷新</el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetSupplyFrom()">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="submitSupplyFrom()">确 定</el-button>
      </span>
    </el-dialog>
    <LookFile :visible.sync="lookFileVisible" :config="lookFileConfig" />
  </div>
</template>
<script>
import mixin from "@/mixins/ICPSmixin.js";
import { queryPage, batchDel, Download, getContract, saveOrUpdate, batchUpdateStatus } from "@/api/smart/penaltyLedger.js";
// import { setgetList } from "@/api/basicConfig/CPYquality.js";
import { getDicType, getUserAutList, getStationByCompanyId } from "@/api/common.js";
import FileComponent from "@/components/File/fileComponent";
import LookFile from "@/components/File/LookFile";
import { queryList } from "@/api/GHnumber/cooperativeUnit";
export default {
  mixins: [mixin],
  components: { FileComponent, LookFile },
  data() {
    return {
      title: "",
      totalSupply: 0,
      supplierDialog: false,
      tableParamSupply: {
        contractSigningSubject: "",
        supplierName: "",
        contractNumber: "", //合同
        page: 1,
        pageSize: 10,
        contractStatus: "",
        contractTypeId: "1", //原物料
        enable: 1,
      },
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      DownloadURL: Download,
      /*表格数据*/
      table: [
        { label: "编号", width: "100", prop: "code", status: true },
        { label: "合同签订主体", width: "auto", prop: "contractSigningSubject", status: true },
        { label: "协调主体", width: "auto", prop: "cooperativeUnit", status: true },
        { label: "合同单位", width: "auto", prop: "supplierName", status: true },
        { label: "协作合同编码", width: "auto", prop: "contractCode", status: true },
        { label: "项目", width: "auto", prop: "projectName", status: true },
        { label: "站点", width: "auto", prop: "stationName", status: true },
        { label: "处罚单编号", width: "auto", prop: "fineNumber", status: true },
        { label: "处罚时间", width: "auto", prop: "fineTime", status: true },
        { label: "处罚依据", width: "auto", prop: "fineReason", status: true },
        { label: "处罚类型", width: "auto", prop: "fineTypeName", status: true },
        { label: "处罚金额（元）", width: "auto", prop: "fineMoney", status: true },
        { label: "填报人", width: "auto", prop: "createUserName", status: true },
        { label: "填报时间", width: "auto", prop: "createTime", status: true },
        { label: "结算时间", width: "auto", prop: "settleTime", status: true },
        { label: "处罚单", width: "auto", prop: "fineFile", status: true },
        { label: "状态", width: "auto", prop: "checkStatus", status: true },
        { label: "操作", width: "180", prop: "", status: true, fiexd: "right" },
      ],
      /*表单页类型，0为无树状，1为有树状，有树状在el-main加上display:flex*/
      pagesType: 0,
      /*添加表单数据*/
      rules: {
        fineTypeId: [{ required: true, message: "请选择处罚类型", trigger: "change" }],
        contractSigningSubjectId: [{ required: true, message: "请选择合同签订主体", trigger: "change" }],
        supplierName: [{ required: true, message: "请输入合同单位", trigger: "blur" }],
        contractCode: [{ required: true, message: "请输入协作合同编码", trigger: "blur" }],
        projectId: [{ required: true, message: "请选择项目", trigger: "change" }],
        cooperativeUnitId: [{ required: true, message: "请选择协作主体", trigger: "change" }],
        stationId: [{ required: true, message: "请选择站点", trigger: "change" }],

        fineTime: [{ required: true, message: "请选择处罚时间", trigger: "change" }],
        fineNumber: [{ required: true, message: "请输入处罚单编号", trigger: "blur" }],
        fineReason: [{ required: true, message: "请输入处罚依据", trigger: "blur" }],
        fineMoney: [{ required: true, message: "请输入处罚金额", trigger: "blur" }],
      },
      fromDate: {
        fineTypeId: "",
        company: "",
        companyId: "",
        contractCode: "",
        contractId: "",
        contractSigningSubject: "",
        contractSigningSubjectId: "",
        cooperativeUnit: "",
        cooperativeUnitId: "",
        id: "",
        projectId: "",
        projectName: "",
        supplierId: "",
        supplierName: "",
        stationId: "",
        stationName: "",
        fineTime: "",
        fineNumber: "",
        fineReason: "",
        fineMoney: "",
        checkStatus: 0,
      },
      ledgerList: [],
      projectList: [],
      contractData: [],
      cooperativeUnitList: [],
      selectData: [],
      pointIdListArr: [],
      siteIdList: [],
      files: [],
      lookFileConfig: {
        filePaths: "",
      },
      lookFileVisible: false,
      selectList: [],
      checkStatus: 0,
      lookStatus: false,
    };
  },
  async created() {
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = {
      ...this.tableParam,
      fineTypeId: "",
      stationId: "",
      cooperativeUnit: "",
      contractSigningSubject: "",
    };
    this.gettableData();
    //查询账号公司下所有站点
    this.pointIdListArr = await getUserAutList(true);
    getDicType({ code: "Punishment_type" }).then(res => {
      if (res.code === 1001) {
        this.ledgerList = res.data.items;
      }
    });
    getDicType({ code: "MATtype" }).then(res => {
      if (res.code === 1001) {
        this.projectList = res.data.items;
      }
    });
  },
  /*
   *copy(data)深拷贝数据,返回拷贝完的数据
   *gettableData获取列表数据
   *load下载
   *SortNum保持序列号
   * UpdateOrDelete禁用，启用，删除
   * submitFromDate保存更新数据
   */
  methods: {
    selectFromDate() {
      if (this.selectList.length > 0) {
        // this.examineDialog = true
        this.$confirm("通过审核的处罚单将进入原物料结算，请确认是否通过审核?", "提示", {
          distinguishCancelAndClose: true,
          confirmButtonText: "通过",
          cancelButtonText: "不通过",
          type: "warning",
        })
          .then(() => {
            this.checkStatus = 3;
            this.batchUpdateStatus();
          })
          .catch(action => {
            console.log(action);
            if (action === "cancel") {
              this.checkStatus = 2;
              this.batchUpdateStatus();
            } else {
              //关闭弹窗
              return;
            }
          });
      } else {
        this.$message({ message: "请选择需要审核数据！", type: "warning" });
      }
    },
    batchUpdateStatus() {
      if (this.selectList.length > 0) {
        let paramArr = this.selectList.map(item => {
          return item.id;
        });
        batchUpdateStatus({ list: paramArr, status: this.checkStatus }).then(res => {
          if (res.code == 1001) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.gettableData();
          } else {
            this.$message({
              message: res.codeMsg,
              type: "warning",
            });
          }
        });
      }
    },
    checkSelect(row) {
      if (row.checkStatus == 0) {
        return true;
      } else {
        return false;
      }
    },
    handleSelectionChange2(rows) {
      this.selectList = JSON.parse(JSON.stringify(rows));
      console.log(" ------------ ", this.selectList);
    },
    /**
     * @Description: 删除附件
     * @Param:
     * @Author: wangwangwang
     */
    deleteFile(index) {
      this.files.splice(index, 1);
    },
    /**
     * @Description: 上传成功
     * @Param:
     * @Author: wangwangwang
     */
    uplodeSuccess(data) {
      console.log(data);
      this.files = [];
      let item = {
        name: data.fileName,
        fileName: data.fileName,
        fileUrl: data.fileUrl,
        path: data.fileUrl,
        fileType: 1,
        type: 1,
        createTime: new Date().Format("yyyy-MM-dd hh:mm:ss"),
      };
      this.files.push(item);
    },
    /*根据公司获取站点*/
    setstationIdlist(id) {
      getStationByCompanyId({ id: id }).then(res => {
        this.siteIdList = res.data;
      });
    },
    /*重置数据*/
    init() {
      this.tableParam = {
        ...this.tableParam,
        fineTypeId: "",
        stationId: "",
        cooperativeUnit: "",
        contractSigningSubject: "",
      };
      this.gettableData();
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
    sizeChangeSupply(value) {
      this.tableParamSupply.pageSize = value;
      this.getSupplyInfo();
    },
    getUint(row) {
      this.files = row.fineFile;
      queryList({ supplierId: row.supplierId,contractId:row.contractId }).then(res => {
        this.cooperativeUnitList = res.data;
      });
    },
    getSupplyInfo() {
      this.supplierDialog = true;
      getContract(this.tableParamSupply).then(res => {
        if (res.code === 1001) {
          this.contractData = res.data.data;
          this.totalSupply = res.data.totalRows;
        }
      });
    },
    handleSelectionChange(val) {
      this.selectData = val;
      if (this.selectData.length > 1) {
        this.$message.warning("只能选择一条");
      }
    },
    DelItem(row) {
      this.$confirm("此操作将永久删除该信息?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "bottom_all_two",
        confirmButtonClass: "bottom_all",
        type: "warning",
      })
        .then(() => {
          let list = [];
          list.push(row.id);
          batchDel(list).then(res => {
            if (res.code == 1001) {
              this.$message.success("删除成功！");
              this.gettableData();
            }
          });
        })
        .catch(() => {});
    },
    submit() {
      console.log(this.fromDate);
      this.$refs.reffromDate.validate(valid => {
        if (valid) {
          this.fromDate.fineFile = JSON.stringify(this.files);
          this.fromDate.checkStatus = 0;
          saveOrUpdate(this.fromDate).then(res => {
            if (res.code === 1001) {
              this.$message.success("添加成功！！");
            } else {
              this.$message.warning("添加失败！！");
              this.$message.warning(res.data);
            }
            this.cooperativeUnitList = [];
            this.selectData = [];
            this.resetFromDate();
            this.gettableData();
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetSupplyFrom() {
      this.supplierDialog = false;
    },
    submitSupplyFrom() {
      let _this = this;
      if (_this.selectData.length < 1) {
        _this.$message.warning("请先选择一条数据");
      } else if (_this.selectData.length == 1) {
        this.$set(this.fromDate, "supplierName", this.selectData[0].supplierName);
        this.$set(this.fromDate, "supplierId", this.selectData[0].supplierId);
        this.$set(this.fromDate, "contractSigningSubjectId", this.selectData[0].contractSigningSubjectId);
        this.$set(this.fromDate, "contractSigningSubject", this.selectData[0].contractSigningSubject);
        this.$set(this.fromDate, "contractId", this.selectData[0].id);
        this.$set(this.fromDate, "contractCode", this.selectData[0].code);
        let projectItem = this.projectList.find(item => item.id == this.selectData[0].rawTypeId);
        if (projectItem) {
          this.$set(this.fromDate, "projectId", projectItem.id);
          this.$set(this.fromDate, "projectName", projectItem.itemName);
        } else {
          this.$set(this.fromDate, "projectId", "");
          this.$set(this.fromDate, "projectName", "");
        }

        queryList({ supplierId: this.selectData[0].supplierId, contractId: this.selectData[0].id }).then(res => {
          if (res.code == 1001 && res.data.length > 0) {
            this.cooperativeUnitList = res.data;
            this.$set(this.fromDate, "cooperativeUnit", res.data[0].collaborativeUnit
);
            this.$set(this.fromDate, "cooperativeUnitId", res.data[0].collaborativeUnitId);
            this.$set(this.fromDate, "taxRate", res.data[0].collaborativeUnitTaxRate);
            this.$set(this.fromDate, "contractCode", res.data[0].collaborativeContractNumber);
          } else {
            this.$set(this.fromDate, "cooperativeUnit", "");
            this.$set(this.fromDate, "cooperativeUnitId", "");
            this.$set(this.fromDate, "taxRate", "");
            this.$set(this.fromDate, "contractCode", "");
          }
        });
        this.setstationIdlist(this.selectData[0].contractSigningSubjectId);
      }
      _this.resetSupplyFrom();
    },
  },
};
</script>

<style lang="scss" scoped>
.dialoginfo-title {
  display: flex;
  justify-content: space-between;
  padding: 0.625rem 0 1.25rem 0;
}
.textline {
  line-height: 2.5rem;
  display: flex;
  > div:first-child {
    width: 6.25rem;
    text-align: right;
  }
  > div:last-child {
    width: 31.25rem;
  }
}
.table_link {
  margin-left: 0.625rem;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}
.el-input,
.el-select {
  width: 15rem;
}
.tabtop {
  width: 35.6875rem;
}
.success-row {
  background: #fffd87 !important;
}
.loadItem {
  text-decoration: none;
  white-space: nowrap;
  padding: 0 20px 20px 0;
  font-weight: normal;
  color: $bg_color;
  cursor: pointer;
  opacity: 0.6;
}
.loadItem:hover {
  opacity: 1;
}
</style>
<style scoped>
.auditVolume >>> .el-input__inner {
  color: red;
}
</style>
